import React from "react";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import dayjs, { Dayjs } from "dayjs";
import CalendarDayWithDot from "./calendar-day-with-dot";

type Props = {
  selectedDate: Dayjs;
  onChange: (d: Dayjs) => void;

  //  from calendar API (dates[])
  bookingDays: Set<string>;

  //  so parent can refetch dots when month changes
  onMonthChange?: (month: Dayjs) => void;
};

export default function CalendarWithDots({
  selectedDate,
  onChange,
  bookingDays,
  onMonthChange,
}: Props) {
  return (
    <div className="mg-cal">
      <div className="mg-cal__legend">
        <div className="mg-cal__legendItem">
          <span className="mg-cal__legendDot mg-cal__legendDot--booked" />
          Orders
        </div>
      </div>

      <DateCalendar
        value={selectedDate}
        onChange={(d) => d && onChange(d)}
        onMonthChange={(d) => onMonthChange?.(dayjs(d))}
        onYearChange={(d) => onMonthChange?.(dayjs(d))}
        reduceAnimations
        slots={{ day: CalendarDayWithDot as any }}
        slotProps={{
          day: { bookingDays } as any,
        }}
      />
    </div>
  );
}
